"use client";

import { useLocation } from "@/contexts/location-context";
import { useIsMobile } from "@/hooks/useIsMobile";
import { isDenver } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import { Button } from "../ui/button";
import { WaitlistModal } from "./waitlist-modal";

export const BottomCTA = () => {
  const isMobile = useIsMobile();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { searchLocation } = useLocation();
  const isLocationDenver = isDenver(searchLocation);

  const image = isMobile ? "bottom-banner-mobile.png" : "bottom-banner.png";

  const actionButton = isLocationDenver ? (
    <Link href="/login">
      <Button
        size={isMobile ? "default" : "xl"}
        className="w-full rounded-full font-bold md:w-auto"
      >
        Get Started
      </Button>
    </Link>
  ) : (
    <Button
      size={isMobile ? "default" : "xl"}
      className="w-full rounded-full font-bold md:w-auto"
      onClick={() => setIsModalOpen(true)}
    >
      Join the Waitlist
    </Button>
  );

  return (
    <>
      <div className="container mx-auto py-16">
        <div className="overflow-hidden rounded-xl bg-canary md:h-auto md:rounded-3xl">
          <div className="flex flex-col items-center gap-5 md:flex-row">
            <div className="w-full px-5 md:w-1/2 md:pl-24">
              <h2 className="mb-6 pt-12 text-center text-3xl font-bold text-smokeyBlack md:pt-0 md:text-left md:text-4xl">
                Ready to See Your Dream Home's True Potential?
              </h2>
              <p className="mb-6 text-center font-semibold text-smokeyBlack md:mb-12 md:text-left md:text-lg">
                Analyze properties smarter, keep everything organized, and
                visualize renovations instantly — all in one powerful platform.
              </p>
              <div className="w-full pb-8 md:w-3/4 md:pb-0">
                <Link href="/login">
                  <Button
                    size={isMobile ? "default" : "xl"}
                    className="w-full rounded-full font-bold md:w-auto"
                  >
                    Try Masterkey Today
                  </Button>
                </Link>
              </div>
            </div>
            <div className="relative hidden md:block md:w-1/2">
              <Image
                src={`/images/landing/bottom-cta/${image}`}
                alt="Masterkey App Screenshot"
                width={600}
                height={400}
                style={{ objectFit: "cover" }}
                className="h-full w-full"
              />
            </div>
          </div>
        </div>
      </div>
      <WaitlistModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
